import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Form, Table, FormControl } from "react-bootstrap";
import PropTypes from "prop-types";
import PropertyOpenWorkOrder from "./PropertyOpenWorkOrder";
import "./PropertyOpenWorkOrders.css";

function PropertyOpenWorkOrders({ openWorkOrders }) {
  const location = useLocation();

  const [filteredOpenWorkOrders, setFilteredOpenWorkOrders] =
    useState(openWorkOrders);

  const handleFilter = (e) => {
    const { value } = e.target;
    let newFilteredWorkOrders = openWorkOrders;
    if (value.length > 2) {
      newFilteredWorkOrders = openWorkOrders.filter(
        (wo) =>
          wo.reference &&
          wo.reference.toString().toLowerCase().includes(value.toLowerCase())
      );
    }
    setFilteredOpenWorkOrders(newFilteredWorkOrders);
  };

  useEffect(() => {}, [location]);

  return (
    <Container className="coreContent mt-4">
      <Row>
        <Col>
          <Form.Label className="form-label-heading">
            Active Work Orders
          </Form.Label>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormControl
            onChange={handleFilter}
            placeholder="Filter by work order reference..."
            className="mb-2"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Reference</th>
                <th>Created</th>
                <th>Type</th>
                <th>Category</th>
                <th>Sub-Category</th>
                <th>State</th>
                <th>Latest Work Item</th>
              </tr>
            </thead>
            <tbody>
              {filteredOpenWorkOrders.map((openWorkOrder) => (
                <PropertyOpenWorkOrder
                  key={openWorkOrder.id}
                  openWorkOrder={openWorkOrder}
                />
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

PropertyOpenWorkOrders.propTypes = {
  openWorkOrders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default PropertyOpenWorkOrders;
